<template>
  <v-dialog v-model="navigation.CRMWhatsappMessageNoteDialogIsVisible" max-width="60vw">
    <v-card max-width="60vw" style="padding: 15px;">
      <div v-if="loader.selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog" style="width: 100%; text-align: center;">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <p style="font-size: large;"><strong>ID de la conversación: </strong>{{ navigation.CRMWhatsappConversation.CRMWhatsappConversationID || 'No registrado' }}</p>
        <p style="font-size: large;"><strong>ID del mensaje: </strong>{{ navigation.CRMWhatsappMessage.CRMWhatsappMessageID || 'No registrado' }}</p>
        <p style="font-size: large;"><strong>ID del contacto: </strong>{{ navigation.CRMWhatsappConversation.CRMWhatsappContact.CRMWhatsappContactID || 'No registrado' }}</p>
        <p style="font-size: large;"><strong>Nombre: </strong>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(navigation.CRMWhatsappConversation.CRMWhatsappContact) }}</p>
        <p style="font-size: large;"><strong>Teléfono: </strong>{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(navigation.CRMWhatsappConversation.CRMWhatsappConversationPhoneNumber) }}</p>
        <div style="display: flex; width: 100%; margin-top: 20px;">
          <v-card
            rounded="lg"
            :color="navigation.CRMWhatsappMessage.CRMWhatsappMessageCreationCRMAgentID == null ? systemInformationData?.CRMAgent?.CRMAgentContactMessageColor || 'primary' : systemInformationData?.CRMAgent?.CRMAgentOwnMessageColor || 'secondary'"
            style="width: 75%; padding: 10px 15px; word-break: break-word; display: inline-block; clear: both; position: relative; cursor: default; user-select: none;"
            :style="{ textAlign: navigation.CRMWhatsappMessage.CRMWhatsappMessageCreationCRMAgentID == null ? 'left' : 'right' }"
          >
            <div v-if="navigation.CRMWhatsappMessage.CRMWhatsappMessageType == 'text' && CRMWhatsappTextMessageContentIsEmoji(navigation.CRMWhatsappMessage.CRMWhatsappTextMessageContent)" style="font-size: 3rem;">
              <p>{{ navigation.CRMWhatsappMessage.CRMWhatsappTextMessageContent }}</p>
            </div>
            <div v-else-if="navigation.CRMWhatsappMessage.CRMWhatsappMessageType == 'text'">
              <p v-html="navigation.CRMWhatsappMessage.CRMWhatsappTextMessageContent.replace(/\n/g, '<br>').replace(/\*(.*?)\*/g, '<strong>$1</strong>').replace(/_(.*?)_/g, '<em>$1</em>')"></p>
            </div>
            <div v-else-if="navigation.CRMWhatsappMessage.CRMWhatsappMessageType == 'contacts'">
              <div style="display: flex;">
                <v-icon color="secondary" style="margin-right: 5px;">mdi-account-circle-outline</v-icon>
                <p>{{ navigation.CRMWhatsappMessage.CRMWhatsappContactMessageName }}</p>
              </div>
              <div style="display: flex;">
                <v-icon color="secondary" style="margin-right: 5px;">mdi-phone-outline</v-icon>
                <p>{{ navigation.CRMWhatsappMessage.CRMWhatsappContactMessagePhoneNumber }}</p>
              </div>
            </div>
            <div v-else-if="navigation.CRMWhatsappMessage.CRMWhatsappMessageType == 'media'">
              <img 
                v-if="navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaExtension == 'webp' || navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaExtension == 'gif'" 
                @click="$root.dialogComponent.openMediaDialog(navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaURL, navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaName, navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaExtension);"
                :src="navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaURL" 
                style="max-width: 30%; height: auto; cursor: pointer;"
              >
              <video 
                v-else-if="navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaExtension == 'mp4'" 
                @click="$root.dialogComponent.openMediaDialog(navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaURL, navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaName, navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaExtension);"
                :src="navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaURL" 
                style="max-width: 30%; height: auto; cursor: pointer;" 
                controls
              ></video>
              <audio 
                v-else-if="navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaExtension == 'mp3'" 
                :src="navigation.CRMWhatsappMessage.CRMWhatsappMediaMessageMediaURL" 
                controls
                style="width: 50%;"
              ></audio>
              <p></p>
            </div>
            <div style="display: flex; align-items: center; font-size: 10px; text-align: right; margin-top: 5px; gap: 5px;" :style="navigation.CRMWhatsappMessage.CRMWhatsappMessageCreationCRMAgentID == null ? 'flow-direction: row-reverse;' : 'flow-direction: row;'">
              <p>{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(navigation.CRMWhatsappMessage.CRMWhatsappMessageCreationDatetime) }}</p>
            </div>
          </v-card>
        </div>
        <v-card color="border" elevation="0" rounded="0" style="margin-top: 25px; padding: 10px;">
          <v-data-table :headers="display.CRMWhatsappMessageNoteHeaders" :items="[{CRMWhatsappMessageNoteID: null}, ...display.CRMWhatsappMessageNote]" :items-per-page="-1" :fixed-header="true" style="max-height: 450px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
            <template v-slot:header.CRMWhatsappMessageNoteID>
              <p><strong>ID</strong></p>
            </template>
            <template v-slot:header.CRMWhatsappMessageNoteCreationCRMAgentName>
              <p><strong>CREACIÓN</strong></p>
            </template>
            <template v-slot:header.CRMWhatsappMessageNoteContent>
              <p><strong>CONTENIDO</strong></p>
            </template>
            <template v-slot:header.CRMWhatsappMessageNoteUpdateCRMAgentName>
              <p><strong>ACTUALIZACIÓN</strong></p>
            </template>
            <template v-slot:item="row">
              <tr v-if="row.item.CRMWhatsappMessageNoteID == null" :style="navigation.CRMWhatsappMessageNote ? 'display: none;' : ''">
                <td colspan="5">  
                  <v-textarea
                    ref="CRMWhatsappMessageNoteContent"
                    v-model="input.CRMWhatsappMessageNoteContent"
                    :disabled="loader.insertCRMWhatsappMessageNote || loader.updateCRMWhatsappMessageNote || loader.deleteCRMWhatsappMessageNote"
                    @keydown="handleCRMWhatsappMessageNoteInputEnter($event)"
                    label="Contenido de la nueva nota del mensaje"
                    variant="solo-filled"
                    density="compact"
                    rows="2"
                    max-rows="5"
                    auto-grow
                    hide-details
                    style="margin: 15px 0;"
                  ></v-textarea>
                </td>
                <td>
                  <v-tooltip :text="validateInputForInsertCRMWhatsappMessageNote(false).result" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon 
                        v-bind="props" 
                        @click="validateInputForInsertCRMWhatsappMessageNote(true).success ? insertCRMWhatsappMessageNote() : null"
                        :disabled="loader.insertCRMWhatsappMessageNote || loader.updateCRMWhatsappMessageNote || loader.deleteCRMWhatsappMessageNote"
                        color="success"
                        class="hoverableElement"
                        :opacity="validateInputForInsertCRMWhatsappMessageNote(false).success ? 1 : 0.5"
                      >
                        mdi-content-save
                      </v-icon>
                    </template>
                  </v-tooltip>
                </td>
              </tr>
              <tr v-else>
                <td>
                  <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Copiar ID al portapapeles" location="top">
                    <template v-slot:activator="{ props }">
                      <p v-bind="props" @click="$generalFunctions.default.copyToClipboard(this, 'ID de la nota del mensaje', 'a', row.item.CRMWhatsappMessageNoteID)" class="hoverableElement"><strong>{{ row.item.CRMWhatsappMessageNoteID }}</strong></p>
                    </template>
                  </v-tooltip>
                </td>
                <td>
                  <v-chip v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteCreationCRMAgentID)" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteCreationCRMAgentID).CRMAgentColor || 'primary'" variant="flat" style="cursor: default; user-select: none;">
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteCreationCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p style="margin: 0;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteCreationCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="xx-small">mdi-clock-outline</v-icon>
                          <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappMessageNoteCreationDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                  <v-chip v-else :color="'primary'" variant="flat" style="cursor: default; user-select: none;">
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p style="margin: 0;">No registrado</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="xx-small">mdi-clock-outline</v-icon>
                          <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappMessageNoteCreationDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </td>
                <td v-if="navigation.CRMWhatsappMessageNote != null && navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteID == row.item.CRMWhatsappMessageNoteID" colspan="2">
                  <v-textarea
                    ref="CRMWhatsappMessageNoteContent"
                    v-model="navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteContent"
                    :disabled="loader.insertCRMWhatsappMessageNote || loader.updateCRMWhatsappMessageNote || loader.deleteCRMWhatsappMessageNote"
                    @keydown="handleCRMWhatsappMessageNoteInputEnter($event)"
                    label="Contenido de la nota del mensaje"
                    variant="solo-filled"
                    density="compact"
                    rows="2"
                    max-rows="5"
                    auto-grow
                    hide-details
                    style="margin: 15px 0;"
                  ></v-textarea>
                </td>
                <td v-else>
                  <p style="word-break: break-word; max-width: 200px;">{{ row.item.CRMWhatsappMessageNoteContent }}</p>
                </td>
                <td v-if="navigation.CRMWhatsappMessageNote == null || navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteID != row.item.CRMWhatsappMessageNoteID">
                  <v-chip v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteUpdateCRMAgentID)" :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteUpdateCRMAgentID).CRMAgentColor || 'primary'" variant="flat" style="cursor: default; user-select: none;">
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteUpdateCRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p style="margin: 0;">{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMWhatsappMessageNoteUpdateCRMAgentID).CRMAgentName || 'No registrado' }}</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="xx-small">mdi-clock-outline</v-icon>
                          <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappMessageNoteUpdateDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                  <v-chip v-else :color="'primary'" variant="flat" style="cursor: default; user-select: none;">
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <div style="display: flex; flex-direction: column;">
                        <p style="margin: 0;">No registrado</p>
                        <div style="display: flex; align-items: center; gap: 5px;">
                          <v-icon size="xx-small">mdi-clock-outline</v-icon>
                          <p style="font-size: xx-small;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappMessageNoteUpdateDatetime) }}</p>
                        </div>
                      </div>
                    </div>
                  </v-chip>
                </td>
                <td v-if="navigation.CRMWhatsappMessageNote == null || navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteID != row.item.CRMWhatsappMessageNoteID">
                  <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Editar nota del mensaje" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon 
                        v-bind="props" 
                        @click="navigation.CRMWhatsappMessageNote = JSON.parse(JSON.stringify(row.item)); $generalFunctions.default.focusInput(this, 'CRMWhatsappMessageNoteContent')" 
                        color="warning" 
                        class="hoverableElement"
                        :disabled="loader.insertCRMWhatsappMessageNote || loader.updateCRMWhatsappMessageNote || loader.deleteCRMWhatsappMessageNote || navigation.CRMWhatsappMessageNote != null"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                  </v-tooltip>
                </td>
                <td v-else>
                  <v-tooltip :text="validateInputForUpdateCRMWhatsappMessageNote(false).result" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon 
                        v-bind="props" 
                        @click="validateInputForUpdateCRMWhatsappMessageNote(true).success ? updateCRMWhatsappMessageNote() : null"
                        :disabled="loader.insertCRMWhatsappMessageNote || loader.updateCRMWhatsappMessageNote || loader.deleteCRMWhatsappMessageNote"
                        color="success"
                        class="hoverableElement"
                        :opacity="validateInputForUpdateCRMWhatsappMessageNote(false).success ? 1 : 0.5"
                      >
                        mdi-content-save
                      </v-icon>
                    </template>
                  </v-tooltip>
                </td>
                <td v-if="navigation.CRMWhatsappMessageNote == null || navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteID != row.item.CRMWhatsappMessageNoteID">
                  <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Eliminar nota del mensaje" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon 
                        v-bind="props" 
                        @click="deleteCRMWhatsappMessageNote(row.item.CRMWhatsappMessageNoteID)" 
                        color="error" 
                        class="hoverableElement"
                        :disabled="loader.insertCRMWhatsappMessageNote || loader.updateCRMWhatsappMessageNote || loader.deleteCRMWhatsappMessageNote || navigation.CRMWhatsappMessageNote != null"
                      >mdi-delete</v-icon>
                    </template>
                  </v-tooltip>
                </td>
                <td v-else>
                  <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Cancelar edición de nota del mensaje" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon 
                        v-bind="props" 
                        @click="navigation.CRMWhatsappMessageNote = null; $generalFunctions.default.focusInput(this, 'CRMWhatsappMessageNoteContent')"
                        :disabled="loader.insertCRMWhatsappMessageNote || loader.updateCRMWhatsappMessageNote || loader.deleteCRMWhatsappMessageNote"
                        color="error"
                        class="hoverableElement"
                      >
                        mdi-close-circle
                      </v-icon>
                    </template>
                  </v-tooltip>
                </td>                
              </tr>
            </template>
            <template v-slot:bottom>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-card>
  </v-dialog>
</template>
  
<style scoped>
</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: {},
    data: () => 
    ({
      input: 
      {
        CRMWhatsappMessageNoteContent: null
      },
      display: 
      {
        CRMWhatsappMessage: null,
        CRMWhatsappMessageNote: [],
        CRMWhatsappMessageNoteHeaders: 
        [
          {title: 'ID', key: 'CRMWhatsappMessageNoteID', sortable: false},
          {title: 'CREACIÓN', key: 'CRMWhatsappMessageNoteCreationCRMAgentName', sortable: false},
          {title: 'CONTENIDO', key: 'CRMWhatsappMessageNoteContent', sortable: false},
          {title: 'ACTUALIZACIÓN', key: 'CRMWhatsappMessageNoteUpdateCRMAgentName', sortable: false},
          {title: null, key: 'CRMWhatsappMessageNoteUpdateAction', sortable: false},
          {title: null, key: 'CRMWhatsappMessageNoteDeleteAction', sortable: false}
        ]
      },
      navigation: 
      {
        CRMWhatsappConversation: null,
        CRMWhatsappMessage: null,
        CRMWhatsappMessageNote: null,
        CRMWhatsappMessageNoteDialogIsVisible: false
      },
      loader: 
      {
        selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog: false,
        insertCRMWhatsappMessageNote: false,
        updateCRMWhatsappMessageNote: false,
        deleteCRMWhatsappMessageNote: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        CRMAgents: false,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    watch: {},

    methods:
    {
      async insertCRMWhatsappMessageNote(){
        this.loader.insertCRMWhatsappMessageNote = true;
        const insertCRMWhatsappMessageNoteRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversation.CRMWhatsappConversationID,
          'CRMWhatsappMessageID': this.navigation.CRMWhatsappMessage.CRMWhatsappMessageID,
          'CRMWhatsappMessageNoteContent': this.input.CRMWhatsappMessageNoteContent
        };
        const insertCRMWhatsappMessageNoteResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMessage/CRMWhatsappMessageNote/functions/insertCRMWhatsappMessageNote', insertCRMWhatsappMessageNoteRequestQuery);
        if (insertCRMWhatsappMessageNoteResult.success){
          const newCRMWhatsappMessageNote = 
          {
            ...insertCRMWhatsappMessageNoteResult.result,
            'CRMWhatsappMessageNoteUpdateCRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID,
            'CRMWhatsappMessageNoteUpdateDatetime': new Date()
          };
          this.display.CRMWhatsappMessageNote = [newCRMWhatsappMessageNote, ...this.display.CRMWhatsappMessageNote];
          this.input.CRMWhatsappMessageNoteContent = null;
          this.$generalFunctions.default.focusInput(this, 'CRMWhatsappMessageNoteContent');
          this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappMessageNote_success', 'success', 'Se ha agregado la nota al mensaje', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappMessageNote_error', 'error', 'Ha ocurrido un error inesperado al agregar la nota al mensaje, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.insertCRMWhatsappMessageNote = false;
      },

      async updateCRMWhatsappMessageNote(){
        this.loader.updateCRMWhatsappMessageNote = true;
        const updateCRMWhatsappMessageNoteRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversation.CRMWhatsappConversationID,
          'CRMWhatsappMessageID': this.navigation.CRMWhatsappMessage.CRMWhatsappMessageID,
          'CRMWhatsappMessageNoteID': this.navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteID,
          'CRMWhatsappMessageNoteContent': this.navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteContent
        };
        const updateCRMWhatsappMessageNoteResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMessage/CRMWhatsappMessageNote/functions/updateCRMWhatsappMessageNote', updateCRMWhatsappMessageNoteRequestQuery);
        if (updateCRMWhatsappMessageNoteResult.success){
          const CRMWhatsappMessageNote = this.display.CRMWhatsappMessageNote.find(CRMWhatsappMessageNote => CRMWhatsappMessageNote.CRMWhatsappMessageNoteID == this.navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteID);
          CRMWhatsappMessageNote.CRMWhatsappMessageNoteContent = this.navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteContent;
          CRMWhatsappMessageNote.CRMWhatsappMessageNoteUpdateCRMAgentName = this.systemInformationData.CRMAgent.CRMAgentName;
          CRMWhatsappMessageNote.CRMWhatsappMessageNoteUpdateCRMAgentColor = this.systemInformationData.CRMAgent.CRMAgentColor;
          CRMWhatsappMessageNote.CRMWhatsappMessageNoteUpdateCRMAgentFontColor = this.systemInformationData.CRMAgent.CRMAgentFontColor;
          CRMWhatsappMessageNote.CRMWhatsappMessageNoteUpdateCRMAgentProfilePictureURL = this.systemInformationData.CRMAgent.CRMAgentProfilePictureURL;
          CRMWhatsappMessageNote.CRMWhatsappMessageNoteUpdateDatetime = new Date().toISOString();
          this.navigation.CRMWhatsappMessageNote = null;
          this.$generalFunctions.default.focusInput(this, 'CRMWhatsappMessageNoteContent');
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappMessageNote_success', 'success', 'La nota del mensaje se ha actualizado exitosamente', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappMessageNote_error', 'error', 'Ha ocurrido un error inesperado al actualizar la nota del mensaje, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.updateCRMWhatsappMessageNote = false;
      },

      async deleteCRMWhatsappMessageNote(CRMWhatsappMessageNoteID){
        this.loader.deleteCRMWhatsappMessageNote = true;
        this.input.CRMWhatsappMessageNoteContent = null;
        const deleteCRMWhatsappMessageNoteRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversation.CRMWhatsappConversationID,
          'CRMWhatsappMessageID': this.navigation.CRMWhatsappMessage.CRMWhatsappMessageID,
          'CRMWhatsappMessageNoteID': CRMWhatsappMessageNoteID
        };
        const deleteCRMWhatsappMessageNoteResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMessage/CRMWhatsappMessageNote/functions/deleteCRMWhatsappMessageNote', deleteCRMWhatsappMessageNoteRequestQuery);
        if (deleteCRMWhatsappMessageNoteResult.success){
          this.display.CRMWhatsappMessageNote = this.display.CRMWhatsappMessageNote.filter(item => item.CRMWhatsappMessageNoteID != CRMWhatsappMessageNoteID);
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappMessageNote_success', 'success', 'La nota del mensaje se ha eliminado exitosamente', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappMessageNote_error', 'error', 'Ha ocurrido un error inesperado al eliminar la nota del mensaje, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        this.loader.deleteCRMWhatsappMessageNote = false;
      },

      validateInputForInsertCRMWhatsappMessageNote(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.input.CRMWhatsappMessageNoteContent == null || !regularExpressionChecker.test(this.input.CRMWhatsappMessageNoteContent)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertCRMWhatsappMessageNote_missingCRMWhatsappMessageNoteContent', 'warning', 'El contenido de la nota del mensaje es obligatorio', null, false);
          return {success: false, result: 'El contenido de la nota del mensaje es obligatorio'};
        } else if (this.input.CRMWhatsappMessageNoteContent.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForInsertCRMWhatsappMessageNote_CRMWhatsappMessageNoteContentTooLong', 'warning', 'El contenido de la nota del mensaje no puede exceder los 65535 caracteres', null, false);
          return {success: false, result: 'El contenido de la nota del mensaje no puede exceder los 65535 caracteres'};
        }
        return {success: true, result: 'Agregar nota del mensaje'};
      },

      validateInputForUpdateCRMWhatsappMessageNote(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteContent == null || !regularExpressionChecker.test(this.navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteContent)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForUpdateCRMWhatsappMessageNote_missingCRMWhatsappMessageNoteContent', 'warning', 'El contenido de la nota del mensaje es obligatorio', null, false);
          return {success: false, result: 'El contenido de la nota del mensaje es obligatorio'};
        } else if (this.navigation.CRMWhatsappMessageNote.CRMWhatsappMessageNoteContent.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForUpdateCRMWhatsappMessageNote_CRMWhatsappMessageNoteContentTooLong', 'warning', 'El contenido de la nota del mensaje no puede exceder los 65535 caracteres', null, false);
          return {success: false, result: 'El contenido de la nota del mensaje no puede exceder los 65535 caracteres'};
        }
        return {success: true, result: 'Actualizar nota del mensaje'};
      },

      async selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog(){
        this.loader.selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog = true;
        const selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialogRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
          },
          'CRMWhatsappConversationID': this.navigation.CRMWhatsappConversation.CRMWhatsappConversationID,
          'CRMWhatsappMessageID': this.navigation.CRMWhatsappMessage.CRMWhatsappMessageID
        };
        const selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappMessage/CRMWhatsappMessageNote/functions/selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog', selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialogRequestQuery);
        if (selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialogResult.success){
          this.display.CRMWhatsappMessageNote = selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialogResult.result;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog_error', 'error', 'Ha ocurrido un error inesperado al consultar las notas del mensaje, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.navigation.CRMWhatsappMessageNoteDialogIsVisible = false;
        }
        this.loader.selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog = false;
      },

      handleCRMWhatsappMessageNoteInputEnter(event){
        if (event.key == 'Enter' && !event.shiftKey && !event.ctrlKey && !event.altKey && !event.metaKey){
          event.preventDefault();
          if (this.navigation.CRMWhatsappMessageNote == null){
            this.validateInputForInsertCRMWhatsappMessageNote(true).success ? this.insertCRMWhatsappMessageNote() : null;
          } else {
            this.validateInputForUpdateCRMWhatsappMessageNote(true).success ? this.updateCRMWhatsappMessageNote() : null;
          }
        }
      },

      CRMWhatsappTextMessageContentIsEmoji(text) {
        const trimmedText = text.trim();
        if (!trimmedText) return false;
        const emojiPattern = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
        const textWithoutEmojis = trimmedText.replace(emojiPattern, '');
        return textWithoutEmojis.trim().length == 0;
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappMessageNoteDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappMessageNoteDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },
     
      async openCRMWhatsappMessageNoteDialog(CRMWhatsappConversation, CRMWhatsappMessage){
        await this.getSystemInformationData();
        this.input.CRMWhatsappMessageNoteContent = null;
        this.loader.selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog = false;
        this.loader.insertCRMWhatsappMessageNote = false;
        this.loader.updateCRMWhatsappMessageNote = false;
        this.loader.deleteCRMWhatsappMessageNote = false;
        this.navigation.CRMWhatsappConversation = JSON.parse(JSON.stringify(CRMWhatsappConversation));
        this.navigation.CRMWhatsappMessage = JSON.parse(JSON.stringify(CRMWhatsappMessage));
        this.navigation.CRMWhatsappMessageNote = null;
        this.navigation.CRMWhatsappMessageNoteDialogIsVisible = true;
        this.$generalFunctions.default.focusInput(this, 'CRMWhatsappMessageNoteContent');
        await this.selectCRMWhatsappMessageNoteFromCRMWhatsappMessageNoteDialog();
      }
    }
  }
</script>